import {
  CatalogFilterLayout,
  EntityListProvider,
  EntityOwnerPicker,
  EntityTagPicker,
  UserListPicker,
  type UserListFilterKind,
} from '@backstage/plugin-catalog-react';
import {
  EntityListDocsTable,
  TechDocsPicker,
} from '@backstage/plugin-techdocs';
import techDocsPlugin from '@backstage/plugin-techdocs/alpha';
import { Container } from '@backstage/ui';
import { TechDocsKindPicker } from './TechDocsKindPicker';

// Mirrors the plugin's own TechDocsIndexPageContent (not exported) with
// TechDocsKindPicker added to the filter column. If a Backstage upgrade
// changes the stock layout, re-check it against that component.
export const TechDocsIndexPageContent = (props: {
  initialFilter: UserListFilterKind;
}) => (
  <Container mt="6">
    <EntityListProvider>
      <CatalogFilterLayout>
        <CatalogFilterLayout.Filters>
          <TechDocsPicker />
          <UserListPicker initialFilter={props.initialFilter} />
          <TechDocsKindPicker />
          <EntityOwnerPicker />
          <EntityTagPicker />
        </CatalogFilterLayout.Filters>
        <CatalogFilterLayout.Content>
          <EntityListDocsTable />
        </CatalogFilterLayout.Content>
      </CatalogFilterLayout>
    </EntityListProvider>
  </Container>
);

// Swaps only the loader of the plugin's `page:techdocs` extension, so its
// path, route ref, title, icon, sub-page input and `initialFilter` config
// keep working. Must be registered under pluginId 'techdocs' (see App.tsx) so
// it resolves to the same extension ID and replaces the original.
export const techDocsIndexPageWithKindFilter = techDocsPlugin
  .getExtension('page:techdocs')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: {
          loader: async () => (
            <TechDocsIndexPageContent initialFilter={config.initialFilter} />
          ),
        },
      });
    },
  });
